import { useCallback, useEffect, useState, useRef } from "react";
import TagsSelectionCard from "./components/TagsSelectionCard/TagsSelectionCard.js";
import CurrentSelectedProductsCard from "../../../CurrentSelectedProductsCard/CurrentSelectedProductsCard.js";
import { useAppMutation } from "../../../../../../../../hooks/index.js";
import TargetedProductsModal from "../../../../../../../modals/TargetedProductsModal/TargetedProductsModal.js";
import { closeModal, openModal } from "../../../../../../../../store/features/modal.js";
import { OPEN_MODAL_TARGETED_PRODUCTS } from "../../../../../../../../constants/modalTypes.js";
import { useAppDispatch } from "../../../../../../../../hooks/redux.js";

const TagsSelectionSection = ({ values, setFormAttribute, productsCount, setProductsCount, currentActionId, setIsProductUsed }) => {
  const dispatch = useAppDispatch();
  const [products, setProducts] = useState([]);
  const [previewProducts, setPreviewProducts] = useState([]);
  const [page, setPage] = useState(1);
  const isInitialLoad = useRef(true);

  const { mutate: mutateGetCountProducts, isLoading: isLoadingGetCountProducts } = useAppMutation({
    url: "/api/products/count/tags",
    reactMutationOptions: {
      onSuccess(data) {
        setProductsCount(() => data.productsCount);
      }
    }
  });

  const { mutate: mutateGetProducts, isLoading: isLoadingGetProducts } = useAppMutation({
    url: "/api/products/by-tags",
    reactMutationOptions: {
      onSuccess(data) {
        setProducts(data.products);
      }
    }
  });

  const { mutate: mutateGetPreviewProducts, isLoading: isLoadingGetPreviewProducts } = useAppMutation({
    url: "/api/products/by-tags",
    reactMutationOptions: {
      onSuccess(data) {
        setPreviewProducts(data.products);
        setIsProductUsed(data.hasActionId)
      }
    }
  });

  useEffect(() => {
    setProducts([]);
    setPreviewProducts([]);
    setProductsCount(0);

    if (values.selectedTags.length) {
      setIsProductUsed(false)
      mutateGetCountProducts({
        tagsSelectionLogic: values.tagsSelectionLogic,
        selectedTags: values.selectedTags,
        exceptionList: !isInitialLoad.current ? [] : values.exceptionList
      });
      mutateGetPreviewProducts({
        tagsSelectionLogic: values.tagsSelectionLogic,
        selectedTags: values.selectedTags,
        pageSize: 3,
        page: 1,
        actionId: currentActionId
      });
    } else {
      setIsProductUsed(false)
    }

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    } else {
      setFormAttribute("exceptionList", []);
    }

  }, [values.tagsSelectionLogic, values.selectedTags, mutateGetCountProducts, mutateGetPreviewProducts]);

  const handleLoadProducts = useCallback((page) => {
    mutateGetProducts({
      tagsSelectionLogic: values.tagsSelectionLogic,
      selectedTags: values.selectedTags,
      pageSize: 10,
      page
    });
  }, [values.tagsSelectionLogic, values.selectedTags, mutateGetProducts]);

  const handleViewModal = useCallback(() => {
    dispatch(openModal({ modalType: OPEN_MODAL_TARGETED_PRODUCTS }));
    handleLoadProducts(1);
  }, [values.tagsSelectionLogic, values.selectedTags, handleLoadProducts, dispatch]);

  const handleCloseModal = useCallback(() => {
    setPage(1);
    setProducts([]);
    dispatch(closeModal());
  }, [setPage, setProducts, dispatch]);

  const handleDelete = useCallback((id) => {
    setFormAttribute("exceptionList", [...values.exceptionList, id]);
    setProductsCount(prev => {
      const newCount = prev - 1;
      return newCount;
    });
  }, [setFormAttribute, values.exceptionList]);

  const handleUndoDeletedProduct = useCallback((id) => {
    setFormAttribute("exceptionList", values.exceptionList.filter(item => item !== id));
    setProductsCount(prev => {
      const newCount = prev + 1;
      return newCount;
    });
  }, [setFormAttribute, values.exceptionList]);

  const handleNext = useCallback(() => {
    handleLoadProducts(page + 1);
    setPage(prev => prev + 1);
  }, [handleLoadProducts, setPage, page]);

  const handlePrevious = useCallback(() => {
    handleLoadProducts(page - 1);
    setPage(prev => prev - 1);
  }, [handleLoadProducts, setPage, page]);

  return (
    <>
      <TagsSelectionCard />
      <CurrentSelectedProductsCard
        previewProducts={previewProducts}
        productsCount={productsCount}
        isLoading={isLoadingGetCountProducts}
        handleViewModal={handleViewModal}
        exceptionList={values.exceptionList}
      />
      <TargetedProductsModal
        isLoading={isLoadingGetProducts}
        hasNext={page * 10 < productsCount}
        hasPrevious={page > 1}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        handleDelete={handleDelete}
        products={products}
        handleCloseModal={handleCloseModal}
        exceptionList={values.exceptionList}
        handleUndoDeletedProduct={handleUndoDeletedProduct}
      />
    </>
  );
};

export default TagsSelectionSection;